import { createTheme } from "@mui/material/styles";
import createMuiButton from "./overrides/Button.js";
import createMuiPickersLayout from "./overrides/PickersLayout.js";
import createMuiMenu from "./overrides/Menu.js";
import createMuiAutocomplete from "./overrides/Autocomplete.js";
import "@mui/material/Button/index.js";
import "@mui/x-date-pickers";
const theme = createTheme({
  typography: {
    fontFamily: "Lato,sans-serif"
  },
  components: {
    MuiButton: createMuiButton(),
    MuiMenu: createMuiMenu(),
    MuiPickersLayout: createMuiPickersLayout(),
    MuiAutocomplete: createMuiAutocomplete()
  }
});
export {
  theme as default
};
